export enum ETipoDocumento {
  ORDEMCARREGAMENTO = 'Ordem de Carregamento',
  CTE = 'CT-e',
  CFE = 'CF-e',
  MDFE = 'MDF-e',
  TERMOSESTADIA = 'Termos Estadia',
  CONTRATOFRETE = 'Contrato Frete',
  CARTAFRETE = 'Carta Frete',
  RECIBOPEDAGIO = 'Recibo de Pedágio',
}
